<template>
  <Teleport to="body">
    <div class="bottom-modal" :class="{active:cActive}">
      <div class="body shadow-lg">
        <Container class="d-flex flex-column">
          <div class="align-self-center">

            <template v-if="cIsUser">

              <template v-if="errorsCount">
                <h4>Обратите внимание:</h4>
                <ul class="errorlist">
                  <li v-for="(title,alias) in errors" :key="alias">
                    {{ title }}
                  </li>
                </ul>
                <div class="text-center">
                  <button @click="resetSelection" :disabled="btnDisabled" class="ms-1 mt-2  btn btn-secondary btn-sm btn-smaller">
                    Cбросить
                  </button>
                </div>

              </template>

              <template v-if="!errorsCount && hasEnoughBalance">
                <div>
                  Ваша персональная скидка {{ cUserSale }}%. Вы экономите: {{ numberFormat(salesumm) }} ₽
                </div>
                <div class="text-center mt-3">
                  <span v-show="loaderShow" class="spinner-border spinner-border-sm text-primary me-3"></span>
                  <button @click="addBooking" :disabled="btnDisabled" class="btn btn-primary btn-sm btn-smaller">Забронировать за
                    {{ numberFormat(currentsumm) }} ₽
                  </button>
                  <button @click="resetSelection" :disabled="btnDisabled" class="ms-1  btn btn-secondary btn-sm btn-smaller">
                    Cбросить
                  </button>
                </div>
              </template>

              <template v-if="!errorsCount && currentCancelSumm >= 0">
                <h4>Отменить выбранные брони?</h4>
                <div>
                  На ваш счет вернется: <span
                    class="fw-bold text-primary">{{ numberFormat(currentCancelSumm) }} ₽</span>
                </div>
                <div v-show="retentionSumm">
                  Будет удержано: <span class="fw-bold text-primary">{{ numberFormat(retentionSumm) }} ₽</span>
                </div>
                <div class="text-center mt-3">
                  <span v-show="loaderShow" class="spinner-border spinner-border-sm text-primary me-3"></span>
                  <button @click="cancelBooking" :disabled="btnDisabled" class="btn btn-primary btn-sm btn-smaller">Отменить
                    брони
                  </button>
                  <button @click="resetSelection" :disabled="btnDisabled" class="ms-1 btn btn-secondary btn-sm btn-smaller">
                    Cбросить
                  </button>
                </div>
              </template>

              <template v-if="!errorsCount && needsBalanceTopUp">
                <h4>Недостаточно средств на балансе</h4>
                <div class="small mb-2">Выбрано броней на сумму: <span
                    class="fw-bold text-primary">{{ numberFormat(currentsumm) }} ₽</span></div>
                <div class="small mt-1">Сумма пополнения:</div>

                <div class="input-group">
                  <input type="number" step="0.01" v-model="addBalanceSumm" class="form-control d-inline"/>
                  <span class="input-group-text px-3">₽</span>
                </div>
                <div class="akcent mt-1">Комиссия сервиса: {{ $store.state.commission }}%</div>
                <div class="text-center mt-2">
                  <span v-show="loaderShow" class="spinner-border spinner-border-sm text-primary me-3"></span>
                  <button @click="confirmModalMessage" class="btn btn-primary btn-sm btn-smaller"
                          :disabled="addBalanceSumm <= 0 || btnDisabled">Пополнить на {{ numberFormat(addBalanceSumm) }}
                    ₽
                  </button>
                  <button @click="resetSelection" :disabled="btnDisabled" class="ms-1 mt-md-0 btn btn-secondary btn-sm btn-smaller">
                    Cбросить
                  </button>
                </div>
              </template>

            </template>

            <template v-if="!cIsUser">
              <div class="text-center">
                <p>Для бронирования кабинета, необходимо авторизоваться.</p>
                <a href="/login" class="btn btn-secondary btn-sm">Войти</a>
              </div>
            </template>
          </div>

        </Container>
      </div>
    </div>
  </Teleport>
  <widget-container-modal/>
</template>

<script>
import Container from "@/components/Container";
import {useToast} from "vue-toastification";

import {API} from "@/getapi";
import ConfirmModal from "@/components/BookingTable/ConfirmModal.vue";
import {container, openModal} from "jenesius-vue-modal";
import MessageModal from "@/components/BookingTable/MessageModal.vue";

const errorTitles = {
  '1hours': 'Минимальное время бронирования 1 час',
  'RangeHour': 'Минимальный промежуток между бронями - 1 час.',
  'MyRangeHour': 'Нельзя оставлять промежуток между бронями в 30 мин.',
  'MyOneHour': 'Минимальное время бронирования 1 час',
}
export default {
  name: "BottomModal",
  components: {WidgetContainerModal: container, Container},
  inject: [
    'searchData',
    'URL_GETWEEK',
    'percentRetention',
    'URL_PAYMENT',
    'URL_BOOKING',
    'URL_CANCEL',
    'URL_SET_MEMORY_BOOKINGS'
  ],
  data() {
    return {
      loaderShow: false,
      btnDisabled: false,
      summ: 0,
      salesumm: 0,
      currentsumm: -1,
      errors: {},
      errorsCount: 0,
      // commission: 2.9,
      addBalanceSumm: 0,
      currentCancelSumm: -1,
      retentionSumm: 0,

      intervalId: null, // id интервала
      isPageVisible: true, // видимость вкладки
      isViewLog: true, // показывать лог консоли
      isUpdateDataInterval: true // Обновлять данные по броням автоматически
    }
  },
  setup() {
    // Get toast interface
    const toast = useToast();
    return {toast}
  },
  created() {
    this.$emitter.on('checkBookingData', () => {
      this.getDataFromAPiLite()
      // console.log("checkData принят в APP");
    })

    // Создаем обработчик изменения видимости страницы
    this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
  },
  mounted() {
    // Добавляем слушатель изменения видимости страницы
    document.addEventListener('visibilitychange', this.handleVisibilityChange);

    // Запускаем интервал
    this.startInterval();
  },
  unmounted(){
    // if (this.intervalId) {
    //   clearInterval(this.intervalId)
    // }

    // Очищаем интервал при размонтировании
    this.stopInterval();

    // Удаляем слушатель
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);

  },
  computed: {
    cUserBalance: function () {
      return this.cIsUser ? Number(this.$store.state.data.user.userBalance) : 0;
    },
    // cUserSale: function () {
    //   return this.cIsUser ? Number(this.$store.state.data.user.userSale) : 0;
    // },
    cUserSale: function () {
      // console.log(this.$store.state.cabData.officeId)
      let officeId = this.$store.state.cabData.officeId
      // console.log('cUserSale','officeId',officeId,this.$store.state.data.user.userSales)
      if (this.cIsUser) {
        if (officeId in this.$store.state.data.user.userSales) {
          return Number(this.$store.state.data.user.userSales[officeId])
        } else {
          return Number(this.$store.state.data.user.userSale);
        }
      }
      return 0;
      // return this.cIsUser ? Number(this.$store.state.user.userSale) : 0;
    },
    cIsUser: function () {
      return this.$store.state.data.user !== false ? true : false;
    },
    currentSummCents: function () {
      return this.moneyToCents(this.currentsumm);
    },
    userBalanceCents: function () {
      return this.moneyToCents(this.cUserBalance);
    },
    hasEnoughBalance: function () {
      return !this.errorsCount && this.currentSummCents >= 0 && this.currentSummCents <= this.userBalanceCents;
    },
    needsBalanceTopUp: function () {
      return !this.errorsCount && this.currentSummCents > this.userBalanceCents;
    },

    cActive: function () {

      let
          store = this.$store.state.selector
          , sizeNew = Object.keys(store.new).length
          , sizeMy = Object.keys(store.my).length
          , sizeErrorNew = Object.keys(store.error.new).length
          , sizeErrorMy = Object.keys(store.error.my).length
          , tmpN = {}
          , tmpM = {}
      if (sizeErrorNew) {
        for (var keyN in store.error.new) {
          tmpN[store.error.new[keyN]] = errorTitles[store.error.new[keyN]]
        }
        this.setErrors(tmpN)
      }
      if (sizeErrorMy) {
        for (var keyM in store.error.my) {
          tmpM[store.error.my[keyM]] = errorTitles[store.error.my[keyM]]
        }
        this.setErrors(tmpM)
      }
      if (!sizeErrorNew && !sizeErrorMy) {
        this.setErrors({})
      }

      if (sizeNew && !sizeErrorNew) {
        var _key
        var priceSumm = 0;
        for (_key in store.new) {
          priceSumm += store.new[_key]['price']
        }
        this.setSumm(priceSumm)
        this.calculateSumm()
        this.setCancelSumm(-1)
      } else {
        this.resetCalculateSumm()
      }
      if (sizeMy && !sizeErrorMy) {
        var _keyM

        var priceCancelSumm = 0;
        var retentionSumm = 0;

        for (_keyM in store.my) {
          let item = store.my[_keyM]
          let priceFix = Number(item['price'])// цена ячейки
          let percent = priceFix / 100 * this.cUserSale;// скидка
          let cPrice = priceFix - percent;// цена ячейки за вычетом скидки
          let cRetentionSumm = 0

          // Делаем удержание если время отмены истекло
          if (item.cancelRetention) {
            cRetentionSumm = cPrice - (cPrice / 100 * this.percentRetention)
          }
          cPrice = cPrice - cRetentionSumm;
          priceCancelSumm += cPrice
          retentionSumm += cRetentionSumm
        }

        this.setCancelSumm(priceCancelSumm)
        this.setRetentionSumm(retentionSumm)
        this.resetCalculateSumm()
      }


      return sizeNew || sizeMy || sizeErrorNew || sizeErrorMy
    }
  },
  watch: {
    // Следим за видимостью страницы
    isPageVisible(newValue) {
      if (newValue) {
        this.startInterval();
      } else {
        this.stopInterval();
      }
    },
    cUserBalance: function () {
      this.updateTopMenuBalance()
    }
  },
  methods: {
    // Остановка интервала
    stopInterval() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
        if(this.isViewLog) console.log('Интервал остановлен (вкладка неактивна)');
      }
    },

    // Запуск интервала
    startInterval() {
      if(!this.isUpdateDataInterval) return

      if (!this.intervalId && this.isPageVisible) {
        // Запускаем интервал на 5 секунд
        this.intervalId = setInterval(this.intervalWorker, 5000);
        if(this.isViewLog) console.log('Интервал запущен (вкладка активна)');
      }
      this.intervalWorker()
    },
    intervalWorker(){
      this.$emitter.emit('checkBookingData')
    },
    // Обработчик изменения видимости страницы
    handleVisibilityChange() {
      this.isPageVisible = !document.hidden;
      if(this.isViewLog) console.log('Видимость страницы изменилась:', this.isPageVisible ? 'активна' : 'неактивна');
    },
    getDataFromAPiLite(addBalanceTag = false){
      let _this = this;

      if(addBalanceTag){
        this.btnDisabled = true
        this.loaderShow = true
      }

      API.get(this.URL_GETWEEK, this.searchData).then(({data}) => {
        if (data.isOK) {

          _this.$store.dispatch('setData', data.result);

          try {
            const selectorNew = _this.$store.state.selector?.new;
            const bookingsData = data.result?.bookings;

            if (!selectorNew || !bookingsData) {
              console.log('Нет данных для обработки');
              console.log(selectorNew)
              console.log(bookingsData)
              return;
            }

            const keysToDelete = [];

            for (let key in selectorNew) {
              if (!Object.prototype.hasOwnProperty.call(selectorNew, key)) continue;

              const [date, sHour, sMinute] = key.split(':');

              // Проверяем, что все части ключа валидны
              if (!date || !sHour || sMinute === undefined) {
                console.warn('Невалидный ключ:', key);
                continue;
              }

              const booking = bookingsData?.[date]?.[sHour]?.[sMinute];

              if (booking?.isOwner === false) {
                console.log('Ячейка занята (не владелец), удаляем:', key);
                keysToDelete.push(key);
              }
            }

            if (keysToDelete.length > 0) {
              _this.$store.commit('selector/removeKeysFromSelectorNew', keysToDelete);
              console.log(`Удалено ключей: ${keysToDelete.length}`, keysToDelete);

              // if(addBalanceTag){
              //   alert("Выбранные слоты заняты")
              //   console.log("Выбранные слоты заняты")
              //
              // }else{
              //   this.toast.error('На текущий момент, часть выбранных Вами слотов были уже забронированы другим пользователем. Мы сбросили выбор уже занятых слотов.');
              // }
              let msg = 'На текущий момент, часть выбранных Вами слотов были уже забронированы другим пользователем. Мы сбросили выбор уже занятых слотов.';
              // this.toast.error(msg);
              this.openModalMessage(msg, 'Внимание!')
            }else if(addBalanceTag){
              this.addBalance();
            }

          } catch (error) {
            this.toast.error('Ошибка при обработке данных: Err 620');
            console.error('Ошибка при обработке данных:', error);
          }

          // console.log(this.$store.state.selector);
          // console.log(data.result);
          if(addBalanceTag){
            this.btnDisabled = false
            this.loaderShow = false
          }
        } else {
          console.error("Error:", data)
        }
      }).catch((err) => {
        API.catch(err)
      })

    },
    openModalMessage(message, title, error = false) {
      const props = {
        message: message,
        title: title,
        error: error
      };
      openModal(MessageModal, props)
    },
    numberFormat(number) {
      return new Intl.NumberFormat("ru", {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(number).replace(',', '.');
    },
    updateTopMenuBalance() {
      const elem = document.querySelector('#top-balance')
      if (elem) {
        elem.innerHTML = this.numberFormat(this.cUserBalance)
      }
    },
    setSumm(priceSumm) {
      this.summ = priceSumm
    },
    setCancelSumm(cancelSumm) {
      this.currentCancelSumm = cancelSumm
    },
    setRetentionSumm(retentionSumm) {
      this.retentionSumm = retentionSumm
    },
    moneyToCents(number) {
      const value = Number(number) || 0;
      return Math.round((value + Number.EPSILON) * 100);
    },
    centsToMoney(cents) {
      return Math.max(0, Number(cents) || 0) / 100;
    },
    roundMoneyUpToCents(number) {
      const value = Number(number) || 0;
      return Math.ceil((value * 100) - 0.000001) / 100;
    },
    calculateSumm() {
      let percent = this.summ / 100 * this.cUserSale;
      this.salesumm = this.summ - (this.summ - percent);
      this.currentsumm = this.roundMoneyUpToCents(this.summ - percent);
      if (this.needsBalanceTopUp) {
        let allSumm = this.centsToMoney(this.currentSummCents - this.userBalanceCents);
        if (allSumm > 0 && allSumm < 1) {
          allSumm = 1.00;
        }
        this.addBalanceSumm = this.roundMoneyUpToCents(allSumm);
      }
    },
    resetCalculateSumm() {
      this.setSumm(0)
      this.salesumm = 0
      this.currentsumm = -1
      this.addBalanceSumm = 0
    },
    setErrors(d) {
      this.errorsCount = Object.keys(d).length
      this.errors = d
    },
    // generate UUID
    // todo это должнен предоставлять платежный провайдер, пока для теста пойдет
    uuidv4() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
          (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
    },
    cancelBooking() {
      // URL_BOOKING
      this.btnDisabled = true
      this.loaderShow = true
      let
          store = this.$store.state.selector
          , sizeMy = Object.keys(store.my).length

      if (sizeMy) {
        console.log(store.my)
        let ids = []
        for (let key in store.my) {
          if (typeof store.my[key]['bookingParam']['id'] !== 'undefined') {
            ids.push(store.my[key]['bookingParam']['id'])
          }
        }
        console.log(ids)


        API.get(this.URL_CANCEL, {
          cancelIds: ids
        }).then(({data}) => {
          console.log(data)
          if (data.isOk) {

            this.toast.info("Отмена бронирования прошло успешно.");
            this.$store.dispatch('selector/resetSelector')
            this.$emitter.emit('bookingDone')

          } else {
            this.toast.error('Ошибка отмены бронирования.');
            console.error("Error:", data.errors)
          }
        }).catch((err) => {
          API.catch(err)
        }).finally(() => {
          this.loaderShow = false
          this.btnDisabled = false
        })
      } else {
        this.toast.error('Ошибка: Отмена бронирования.[нет данных]');
      }
    },
    resetSelection() {
      this.$emitter.emit('resetMemoryDataSelected')
      this.$store.dispatch('selector/resetSelector')
    },
    confirmModalMessage() {
      const props = {
        message: 'До оплаты выбранные слоты блокируются на 15 минут и остаются за Вами. По истечении времени, слоты будут свободны для бронирования другими участниками.',
        title: 'Внимание',
        error: false
      };
      this.$emitter.on('autoAddBooking', () => {
        // this.addBalance();
        this.getDataFromAPiLite(true);
      })
      openModal(ConfirmModal, props)
    },
    addBooking() {
      // URL_BOOKING
      // console.log('URL_BOOKING')
      this.btnDisabled = true
      this.loaderShow = true
      let
          store = this.$store.state.selector
          , sizeNew = Object.keys(store.new).length

      if (sizeNew) {
        console.log(store.new)

        let bookings = Object.assign({}, store.new)
        // for (let key in bookings) {
        //   bookings[key]['date'] = this.$store.state.date
        // }
        console.log(bookings)

        API.get(this.URL_BOOKING, {
          bookings: bookings
        }).then(({data}) => {
          console.log(data)
          if (data.isOk) {
            // this.loaderShow = false
            // this.btnDisabled = false
            this.toast.info("Бронирование прошло успешно.");

            this.$store.dispatch('selector/resetSelector')
            this.$emitter.emit('bookingDone')
            console.log("Бронирование прошло успешно.")
          } else {
            var errorMessage = data.errors.message
            var errorCode = data.errors.code
            this.openModalMessage('Code:' + errorCode + '<br> Message: ' + errorMessage, 'Ошибка бронирования.', true)
            // this.toast.error('Ошибка бронирования.');
            console.error("Error:", data.errors)
          }
        }).catch((err) => {
          API.catch(err)
        }).finally(() => {
          this.loaderShow = false
          this.btnDisabled = false
        })
        // this.loaderShow = false
        // this.btnDisabled = false
      } else {
        this.toast.error('Ошибка бронирования.[нет данных]');
      }

    },
    addBalance() {
      this.btnDisabled = true
      this.loaderShow = true
      // console.log('Пополняем баланс на сумму: ', this.addBalanceSumm)
      this.$emitter.off('autoAddBooking')

      let
          store = this.$store.state.selector
          , sizeNew = Object.keys(store.new).length

      if (sizeNew) {
        let bookings = Object.assign({}, store.new)

        API.get(this.URL_SET_MEMORY_BOOKINGS, {
          bookings: bookings
        }).then(({data}) => {
          // console.log(data)
          if (data.isOK) {
            this.loaderShow = false
            this.btnDisabled = false
            let officeId = this.$store.state.cabData.officeId;
            window.location.href = "/add-balance?sum=" + this.addBalanceSumm + '&booking=1&office_id='+officeId;
          } else {
            // this.toast.error('[382] Ошибка отправки данных о бронировании.');
            this.toast.error('Ошибка: ' + data.errors.message);
            console.error("Ошибка:", data.errors.message)
          }
        }).catch((err) => {
          API.catch(err)
        }).finally(() => {
          this.loaderShow = false
          this.btnDisabled = false
        })
      }


      // let _this = this
      // window.location.href = "/add-balance?sum=" + this.addBalanceSumm;
      // API.get(this.URL_PAYMENT, {
      //   summ: this.addBalanceSumm,
      //   paymentUuid: this.uuidv4()
      // }).then(({data}) => {
      //   if (data.isOk) {
      //     this.loaderShow = false
      //     this.btnDisabled = false
      //     this.toast.info("Баланс пополнен на: " + this.numberFormat(this.addBalanceSumm) + ' ₽');
      //     this.$store.dispatch('updateUserBalance', this.addBalanceSumm + this.cUserBalance)
      //   } else {
      //     this.toast.error('Ошибка пополнения баланса.');
      //     console.error("Error:", data.errors)
      //   }
      // }).catch((err) => {
      //   API.catch(err)
      // }).finally(() => {
      //   this.loaderShow = false
      //   this.btnDisabled = false
      // })
    },
  }
}
</script>

<style scoped>
.akcent {
  font-size: .9rem;
  display: block;
  margin: 0 auto;
  color: #db971a;

}

.bottom-modal {
  position: fixed;
  width: 100%;
  z-index: 1100;
  left: 0;
  bottom: -250px;
  opacity: .5;
  /* display: none; */
  border-top: 1px solid #ebdabe;
  transition: all ease .5s;
}

.bottom-modal.active {
  position: fixed;
  bottom: 0;
  opacity: 1;
}

.body {
  background: #FFF8DA;
  padding: 2rem 2rem;
  border-radius: 10px 10px 0 0;
}

.errorlist {
  margin: 0;
  padding: 0.5rem 3rem;
  background: #ffdbac;
  color: #905d1a;
  border: 1px solid #e5b678;
  border-radius: 10px;
}

.errorlist li {
  list-style: square;
}
.btn-smaller{
  padding: .2rem .7rem;
  border-radius: 20px;
}
</style>